<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<section class="main_layout uh_spc">
  <div class="container">
    <div class="main_grid">
      <!-- Left Side (Menu) - Always Visible -->
      <!-- Add w-100 class when in sidebar mode so it takes full width of drawer -->
      <div class="lt" [ngClass]="{'w-100': isMobileSidebar}">
        <div class="whiteBox profile_bx">
          <figure class="cover_img">
            <img src="{{assetsConst.studentProfileCover}}" alt="img" />
          </figure>
          @if (profile()) {
            <div class="user_profile hd_5">
              <figure>
                <img [src]="profile()?.image" alt="profile" />
              </figure>
              <div class="profile_cnt">
                <h3>{{ profile()?.fullName ?? '' }}</h3>
                <p><small>{{ profile()?.email ?? '' }}</small></p>
              </div>
            </div>
          }

          <p-button
            (click)="onMenuClose()"
            size="small"
            label="View Profile"
            [routerLink]="profileLink"
          />
        </div>

        <ul class="whiteBox menu_list">
          @for (item of menuItems; track $index) {
            <li [routerLink]="item.path"  
                routerLinkActive="active" 
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="onMenuItemClick(item, $event)"
                (keydown.enter)="onMenuItemClick(item, $event)"
                (keydown.space)="onMenuItemClick(item, $event)" 
                [tabindex]="item.action === 'logout' ? 0 : -1"
                [attr.role]="item.action === 'logout' ? 'button' : null"
                [class.logout-item]="item.action === 'logout'"
                [style.cursor]="item.action === 'logout' ? 'pointer' : 'default'">
              <figure>
                <img [src]="item.icon" alt="icon" />
              </figure>
              <span> {{ item.label }}</span>
            </li>
          }
        </ul>

        <ul class="whiteBox menu_list">
          @for (item of menuItems2; track $index) {
            <li [routerLink]="item.path"  
                routerLinkActive="active" 
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="onMenuItemClick(item, $event)"
                (keydown.enter)="onMenuItemClick(item, $event)"
                (keydown.space)="onMenuItemClick(item, $event)"
                [tabindex]="item.action === 'logout' ? 0 : -1"
                [attr.role]="item.action === 'logout' ? 'button' : null"
                [class.logout-item]="item.action === 'logout'"
                [style.cursor]="item.action === 'logout' ? 'pointer' : 'default'">
              <figure>
                <img [src]="item.icon" alt="icon"/>
              </figure>
              <span> {{ item.label }}</span>
            </li>
          }
        </ul>

        <ul class="whiteBox menu_list">
          @for (item of footerMenuItems; track $index) {
            @if (item.action === 'logout') {
              <li (click)="btn_logOut()" 
                  (keydown.enter)="btn_logOut()"
                  (keydown.space)="btn_logOut()"
                  tabindex="0"
                  role="button"
                  class="logout-item" 
                  style="cursor: pointer;"
                  [attr.aria-label]="'Logout from application'">
                <figure>
                  <img [src]="item.icon" alt="icon" />
                </figure>
                <span>{{ item.label }}</span>
              </li>
            } @else {
              <li [routerLink]="item.path"  
                  routerLinkActive="active" 
                  (click)="onMenuItemClick(item, $event)"
                  [routerLinkActiveOptions]="{ exact: true }">
                <figure>
                  <img [src]="item.icon" alt="icon" />
                </figure>
                <span>{{ item.label }}</span>
              </li>
            }
          }
        </ul>
      </div>

      <!-- Right Side (Router Outlet) - HIDDEN IN DRAWER/SIDEBAR MODE -->
      <!-- This prevents the "duplicate router-outlet" bug -->
      @if (!isMobileSidebar) {
        <div class="rt">
          <router-outlet></router-outlet>
        </div>
      }
    </div>
  </div>
</section>
